import './styles/main.css';
import './styles/phase-b3.css';
import './styles/phase-b4.css';
import './styles/dashboard.css';
import { route } from './router.js';
import { onAuthChange } from './lib/supabase.js';
import { setupChartDefaults } from './lib/dashboard.js';

setupChartDefaults();

window.addEventListener('hashchange', route);
window.addEventListener('DOMContentLoaded', route);

onAuthChange((event) => {
  if (event === 'SIGNED_OUT') window.location.hash = '#/login';
  else if (event === 'SIGNED_IN' || event === 'TOKEN_REFRESHED') route();
});
